import React, { useState, useEffect } from "react";
import { PropTypes } from "prop-types";
import useTranslation from "next-translate/useTranslation";

import staticIntlTranslatorToString from "shared/utils/staticIntlTranslatorToString";
import RenderStringHtml from "shared/components/atoms/RenderStringHtml";

import Widget from "shared/components/templates/Widget";
import { Container } from "./styles";

const InfoContent = ({ sectionData }) => {
  const [content, setContent] = useState("");
  const { lang } = useTranslation()

  useEffect(() => {
    const translatedContent = staticIntlTranslatorToString(
      sectionData?.content,
      lang
    );
    setContent(
      translatedContent?.replace(
        "<a",
        '<a target="_blank" rel="noopener noreferrer"'
      )
    );
  }, [sectionData]);

  return (
    <Widget
      styleName="gx-card-tabs gx-card-tabs-right gx-card-profile"
      transparentDarkDisabled
      title={staticIntlTranslatorToString(sectionData?.name, lang)}
    >
      <Container>
        <RenderStringHtml value={content} />
      </Container>
    </Widget>
  );
};

InfoContent.propTypes = {
  sectionData: PropTypes.object.isRequired,
};

export default InfoContent;
